import { OneEyeService } from './api'


const krtiWebUrl = process.env.REACT_APP_WEB_BASE_URL;


export const signAuthByEmailAndPassword = async (req) => {
    try {
        return await OneEyeService.post(`${krtiWebUrl}/api/Authentication
        `, req)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}
export const getUserList = async () => {
    try {
        return await OneEyeService.get(`${krtiWebUrl}/api/Authentication`)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}